module.exports = __webpack_public_path__ + "img/icon-twitter.2258e4ca.svg";